import store from 'store';
import { message } from 'antd';
import { vendorBasicCheck, getBusinessTypes, getPrimary, getSecondary, addSupplier, getSupplier, deleteSupplier, saveAndCheck } from '../services/api';
import { saveFinishedStep } from '../views/Register/Basic';
import { addPathInCategory } from '../utils/index';


function init() {
  return {
    basicCompanyData: store.get('basicCompanyData') || {},
    licenseAttachment: store.get('licenseAttachment') || [],
    companyAttachment: store.get('companyAttachment') || [],
    // financeComplianceAttachments: store.get('financeComplianceAttachments') || [],
    requiredAgentBrand: false,
    requiredSupplyCategory: false,
    taxRateDisabled: true,
    requiredVatNumber: false,
    employyerDisabled: true,
    businessTypes: [],
    primaryCategory: [],
    secondCategory: [],
    businessTypeValue: '',
    primaryValue: '',
    secondValue: [],
    businessTypesObj: {},
    primaryObj: {},
    secondObj: {},
    categoryList: store.get('categoryList') || [],
    textBtnVisible: true,
    selectVisible: false,
    addBtnVisible: false
  };
}
export default {
  namespace: 'companyInfoRegister',

  state: init(),
  effects: {
    *getSupplier(_, { call, put }) {
      const result = yield call(getSupplier);
      if (result.success) {
        const data = result.data.map((value) => {
          return addPathInCategory(value);
        });
        yield put({
          type: 'updateState',
          payload: {
            data: {
              categoryList: data
            }
          }
        });
      } else {
        result.msg && message.error(result.msg);
      }
      return result;
    },
    *getBusinessTypes(_, { call, put }) {
      const result = yield call(getBusinessTypes);
      if (result.success) {
        yield put({
          type: 'updateState',
          payload: {
            data: {
              businessTypes: result.data
            }
          }
        });
      } else {
        result.msg && message.error(result.msg);
      }
    },
    *getPrimary({ payload }, { call, put }) {
      const result = yield call(getPrimary, payload.data);
      if (result.success) {
        yield put({
          type: 'updateState',
          payload: {
            data: {
              primaryCategory: result.data
            }
          }
        });
      } else {
        result.msg && message.error(result.msg);
      }
    },
    *getSecondary({ payload }, { call, put, select }) {
      const businessTypeValue = yield select(state => state.companyInfoRegister.businessTypeValue);
      const result = yield call(getSecondary, { businessTypes: businessTypeValue, Primary: payload.data });
      if (result.success) {
        yield put({
          type: 'updateState',
          payload: {
            data: {
              secondCategory: result.data
            }
          }
        });
      } else {
        result.msg && message.error(result.msg);
      }
    },
    *add({ payload }, { call, put }) {
      const result = yield call(addSupplier, payload.data);
      if (result.success) {
        yield put({
          type: 'getSupplier',
        });
      } else {
        result.msg && message.error(result.msg);
      }
      return result;
    },
    *delete({ payload }, { call, put }) {
      const result = yield call(deleteSupplier, payload.data);
      if (result.success) {
        yield put({
          type: 'getSupplier',
        });
      } else {
        result.msg && message.error(result.msg);
      }
    },
    *vendorBasicCheck({ payload: { data, history } }, { call }) {
      const result = yield call(vendorBasicCheck, data);
      if (result.success) {
        saveFinishedStep(3);
        history.push('/register/basic/step-four');
      } else {
        result.msg && message.error(result.msg);
      }
    },
    *saveAndCheck({ payload: { data, history } }, { call }) {
      const result = yield call(saveAndCheck, data);
      if (result.success) {
        history.push('/register/basic/step-three');
      } else {
        result.msg && message.error(result.msg);
      }
    },
  },
  reducers: {
    updateState(state, { payload: { data } }) {
      return {
        ...state,
        ...data
      };
    },
    clear() {
      return init();
    }
  }
};
